<script setup lang="ts">
import {Notice} from "@/types";
import {TimeFormatter} from "../../../utils/common.ts";

const props = defineProps<{
  notice: Notice
}>()

const emit = defineEmits(["onEdit", "onDelete"])

const onEdit = () => {
  emit("onEdit", props.notice.id);
}

const onDel = () => {
  emit("onDelete", props.notice.id);
}
</script>

<template>
  <div class="flex items-center mt-.75rem cursor-pointer mr-9rem notice-container mt-.875rem">
    <img src="@/assets/image/icon/icon-notice.png" alt="公告" class="w-1rem h-1rem mr-.75rem" />
    <div class="text-#161616 text-.875em mr-.75rem">{{ notice.title }}</div>
    <div class="text-#939393 text-.875em">
      {{ TimeFormatter.formatTime(notice.create_time * 1000) }}
    </div>
    <div class="ml-6.875rem gap-1rem cursor-pointer flex invisible op-container">
      <div class="text-#939393 text-.875em" @click="onEdit">编辑</div>
      <div class="text-#939393 text-.875em" @click="onDel">删除</div>
    </div>
  </div>
</template>

<style scoped>
.notice-container:hover > .op-container {
  visibility: visible;
}
</style>